import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";
import { IThumbFilter } from "./thumb.filter";

export interface IFileIconFilter {
    (filepath: string, root: string): string;
}
// declare module "angular" {
//     interface IFilterService {
//         (name: "fileIcon"): IFileIconFilter;
//     }
// }

@NgFilter({
    token: Token.FileIconFilter,
    dependencies: [
        Token.$Filter,
        Token.StorageService
    ]
})
export class FileIconFilter {
    constructor(
        private $filter: ng.IFilterService,
        private storageService: StorageService
    ) {
        return ((
            filepath: string,
            root: string = "media"
        ) => {
            let ext = filepath && filepath.substr(filepath.lastIndexOf("."));
            if (ext) ext = ext.toLowerCase();
            let imageName = "";

            switch (ext) {
                case ".docx":
                case ".doc":
                    imageName = "docx.png";
                    break;
                case ".xlsx":
                case ".xls":
                    imageName = "xlsx.png";
                    break;
                case ".txt":
                    imageName = "txt.png";
                    break;
                case ".xml":
                    imageName = "xml.png";
                    break;
                case ".pdf":
                    imageName = "pdf.png";
                    break;
                case ".sldasm":
                    imageName = "sldasm.png";
                    break;
                case ".sldprt":
                    imageName = "sldprt.png";
                    break;
                case ".slddrw":
                    imageName = "slddrw.png";
                    break;
                case ".iam":
                    imageName = "default.png";
                    break;
                case ".ipt":
                    imageName = "default.png";
                    break;
                case ".idw":
                    imageName = "default.png";
                    break;
                case ".dwg":
                    imageName = "dwg.png";
                    break;
                case ".dxf":
                    imageName = "dxf.png";
                    break;
                case ".webm":
                case ".ogv":
                case ".mp4":
                case ".3gp":
                case ".avi":
                    imageName = "video.png";
                    break;
                case ".png":
                case ".gif":
                case ".jpg":
                case ".bmp":
                    if (root == "media") {
                        return (($filter as any)("thumb") as IThumbFilter)(filepath);
                    } else {
                        imageName = "image.png";
                        break;
                    }
                case ".zip":
                    imageName = "zip.png";
                    break;
                default:
                    imageName = "default.png";
                    break;
            }

            return storageService.getAssetUrl("images/file_icons/" + imageName);

        }) as any;
    }

}
